import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/globals.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import registerServiceWorker from './registerServiceWorker';
import { StatementProvider } from './components/contexts/StatementContext';
import { AudioProvider } from './components/contexts/AudioContext';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const root = createRoot(rootElement);

// Render the application within the context providers
root.render(
  <React.StrictMode>
    <StatementProvider>
      <AudioProvider>
        <App baseUrl={baseUrl} />
      </AudioProvider>
    </StatementProvider>
  </React.StrictMode>
);

// Register the service worker for offline capabilities
registerServiceWorker();
